export default "__VITE_ASSET__Hju6iXtF__"